export default "__VITE_ASSET__kSd4RG_l__"